import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "oc-res-tapservice",
  "use": "oc-res-tapservice-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" id=\"oc-res-tapservice\"><path d=\"M896.17 160h-768a64.19 64.19 0 0 0-64 64v512a64.19 64.19 0 0 0 64 64h192v64h384v-64h192a64.19 64.19 0 0 0 64-64V224a64.19 64.19 0 0 0-64-64z m0 576h-768V224h768z\" p-id=\"3131\" /><path d=\"M416.17 640h64V352h-32l-32 32-64 64h64v192zM608.17 608l64-64h-64V352h-64v288h32l32-32z\" p-id=\"3132\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol